import { aboutStats } from '../data';
import s from './About.module.css';

const PILLS = ['✓ Business Growth','✓ Mobile & Web','✓ Creative UI/UX','✓ DevOps & Cloud','✓ Honest Timelines','✓ Post-Launch Support'];

export default function About() {
  return (
    <section id="about-section" className="dark-section" aria-label="About">
      <div className={`section-inner ${s.grid}`}>

        {/* Visual */}
        <div className={s.visual}>
          <div className={s.top}>
            <div className={s.bigWord}>NEXT<br />IT<br />ERA</div>
            <div className={s.statsGrid}>
              {aboutStats.map(({ value, label }) => (
                <div key={label} className={s.statCard}>
                  <div className={s.statVal}>{value}</div>
                  <div className={s.statLbl}>{label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className={s.bottom}>
            <div className={s.botIcon}>🤝</div>
            <div>
              <div className={s.botTitle}>Your trusted tech partner</div>
              <div className={s.botSub}>Dubai, UAE — Working globally</div>
            </div>
          </div>
        </div>

        {/* Text */}
        <div className={s.text}>
          <div className="kicker">
            <div className="kicker-line-dark" />
            <span className="kicker-text-dark">About Us</span>
          </div>
          <h2 className={`section-h ${s.heading}`}>We make tech feel<br />less scary 😊</h2>
          <p className={s.p}>We work closely with our clients — not like a cold vendor, but like a trusted tech partner. We ask the right questions, listen carefully, and build exactly what you need.</p>
          <p className={s.p}>Whether you're a startup with a bold idea or an enterprise ready to modernise — we're here to help in English, French, or Arabic.</p>
          <div className="pill-list">
            {PILLS.map(p => <div key={p} className="pill-dark">{p}</div>)}
          </div>
          <a href="#contact" className="btn-dark">Work With Us →</a>
        </div>

      </div>
    </section>
  );
}
